const deepClone = (o: object) => JSON.parse(JSON.stringify(o));

export const cleanObject = (o: object): object => {
  const newObj = deepClone(o);
  for (const key in newObj) {
    if (newObj[key] === "") {
      delete newObj[key];
    }
  }
  return newObj;
};

/**
 * makeGetUrl (url, params)
 *
 * @description
 * object 를 parameter 로 붙여 url 만들어 리턴합니다.
 *
 * @param {string} url - url
 * @param {object} params - parameter data
 */
export function makeGetUrl(url: string, params: object) {
  const paramStr = Object.entries(cleanObject(params))
    .map(([k, v]) => `${k}=${v}`)
    .join("&");
  return `${url}?${paramStr}`;
}

export function convertFormData(o: object): object {
  const dt = new FormData();
  Object.keys(o).forEach((k: string, v: any) => {
    dt.append(k, v);
  });
  return dt;
}
